<template>
  <div>
    <Banner />
    <div class="container-fluid">
      <div class="container" v-if="isPublic || isReviewer">

        <ReviewModeInfo class="mb-4" />

        <CreatePlanSummary :studentType="selectedPreferences.studentType" :studyOption="selectedPreferences.studyOption"
          :teachingPeriod="selectedPreferences.teachingPeriod"
          :startYear="selectedPreferences.startYear" />

        <div class="row d-flex align-items-center mb-4 print-hide">
          <div class="col-6">
            <a class="link-grey" @click="baseStep.previous"><i class="far fa-chevron-left"></i>Back to unit select</a>
          </div>
          <div class="col-6 text-right">
            <div class="btn-group" v-if="selectedPreferences.studentType !== 'Transnational'">
              <button class="btn btn-light" type="button" v-on:click="toggleView('plan')" :class="viewMode == 'plan' ? 'selected' : ''">Course plan</button>
              <button class="btn btn-light" type="button" v-on:click="toggleView('fees')" :class="viewMode == 'fees' ? 'selected' : ''">Fee summary</button>
            </div>
          </div>
        </div>

        <transition name="fade" mode="out-in">
          <template v-if="viewMode == 'plan'">
            <CourseCreatePlanView />
          </template>

          <template v-if="viewMode == 'fees' && selectedPreferences.studentType !== 'Transnational'">
            <CourseFeeSummaryView />
          </template>
        </transition>

      </div>
      <div v-else class="container">
        <Reauthenticate />
      </div>

    </div>
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import useBaseStep from 'client/js/composition/base-step'
import { mapGetters, mapActions } from 'vuex'

import Banner from './common/Banner.vue'
import ReviewModeInfo from './common/ReviewModeInfo.vue'
import CreatePlanSummary from './CreatePlanSummary.vue'
import CourseCreatePlanView from './CourseCreatePlanView.vue'
import CourseFeeSummaryView from './CourseFeeSummaryView.vue'
import Reauthenticate from './common/Reauthenticate.vue'

export default {
  components: { Banner, CreatePlanSummary, CourseCreatePlanView, CourseFeeSummaryView, ReviewModeInfo, Reauthenticate },
  setup(props, context) {
    return {
      baseStep: useBaseStep(props, context)
    }
  },
  data() {
    return {
      loading: false,
      plan: null,
      working: false,
      viewMode: 'plan'
    }
  },
  computed: {
    ...mapGetters({
      isReviewer: 'global/isReviewer',
      course: 'courses/getSelectedCourse',
      isPublic: 'courses/isPublic',
      selectedPreferences: 'preferences/getSelectedStudyPreferences',
      selectedItems: 'units/getSelectedCurriculumItems'
    })
  },
  methods: {
    toggleView(view) {
      this.viewMode = view
      // Analytics event on button click.
      if (this.$gtm.enabled())
        this.$gtm.trackEvent({
          event: 'site interaction',
          category: 'Course Plan and Fees',
          action: 'click',
          label: 'View Changed',
          value: view,
          rest: {
            course: {
              code: this.course.code,
              name: this.course.name
            }
          }
        })
    }
  }
}
</script>

<style></style>
